import updateWalletStorage from './updateWalletStorage.js';
import debugWallet from './debugWallet.js';
import validatePaymentsInfo from './validatePaymentsInfo.js';
import calculateTotalBudget from './calculateTotalBudget.js';
import calculateMonthlyBudget from './calculateMonthlyBudget.js';
import { walletStorageKeys } from '../constants/walletStorageKeys.js';
const BUDGET_FACTORS = ['creditType', 'loanTerm', 'interestRate', 'budget', 'monthlyBudget', 'downPayment', 'downPaymentPercent', 'tradeIn'];

// only recalculate budget/monthlyBudget if the payload contains one of the listed keys and the user is not clearing their budget/monthlyBudget
function shouldRecalculateBudgetOrMonthlyPayment(payload, paymentOption) {
  return paymentOption !== 'lease' && Object.keys(payload).some(budgetKeys => BUDGET_FACTORS.includes(budgetKeys)) && !(Number(payload.monthlyBudget) === 0 || Number(payload.budget) === 0);
}
async function calculateTotalBudgetIfNeeded(validatedPaymentsInfo, payload, paymentCalculationFetcher, budgetSummaryType, paymentOption, response) {
  // if budget panel is toggled to monthly payment || calculation is triggered by NDS || default monthly budget is initialized
  const shouldCalculateTotalBudget = (validatedPaymentsInfo.monthlyBudget || payload.monthlyBudget) && (budgetSummaryType === 'monthly' && paymentOption !== 'lease' || payload.interactions?.fromNds || payload.interactions?.isInitialBudget);
  response.hasMonthlyBudget = shouldCalculateTotalBudget;
  if (shouldCalculateTotalBudget) {
    const calculatedBudget = await calculateTotalBudget({
      payload,
      paymentsInfo: validatedPaymentsInfo,
      paymentCalculationFetcher
    });
    if (typeof calculatedBudget === 'number') {
      payload.budget = Math.floor(calculatedBudget);
      return true;
    }
  }
  return false;
}
async function calculateMonthlyBudgetIfNeeded(validatedPaymentsInfo, payload, paymentCalculationFetcher) {
  if (validatedPaymentsInfo.budget || payload.budget) {
    const calculatedMonthlyBudget = await calculateMonthlyBudget({
      payload,
      paymentsInfo: validatedPaymentsInfo,
      paymentCalculationFetcher
    });
    if (typeof calculatedMonthlyBudget === 'number') {
      payload.monthlyBudget = Math.floor(calculatedMonthlyBudget);
      return true;
    }
  }
  return false;
}
async function calculateBudget(_ref) {
  let {
    currentPaymentsInfo = {},
    payload = {},
    paymentOption,
    budgetSummaryType,
    myWalletConfig = {},
    paymentCalculationFetcher
  } = _ref;
  const validatedPaymentsInfo = validatePaymentsInfo(currentPaymentsInfo, myWalletConfig);
  const response = {
    hasMonthlyBudget: false,
    hasUpdatedBudget: false
  };
  if (shouldRecalculateBudgetOrMonthlyPayment(payload, paymentOption)) {
    await calculateTotalBudgetIfNeeded(validatedPaymentsInfo, payload, paymentCalculationFetcher, budgetSummaryType, paymentOption, response);
    await calculateMonthlyBudgetIfNeeded(validatedPaymentsInfo, payload, paymentCalculationFetcher);
  }
  response.hasUpdatedBudget = payload.budget && payload.budget !== currentPaymentsInfo.budget || payload.monthlyBudget && payload.monthlyBudget !== currentPaymentsInfo.monthlyBudget;
  return response;
}
function clearBudgetIfNeeded(payload) {
  if (Number(payload.monthlyBudget) === 0 || Number(payload.budget) === 0) {
    debugWallet('User has cleared budget value');
    payload.monthlyBudget = null;
    payload.budget = null;
  }
}
function updateWalletIdIfNeeded(walletStorageService, payload) {
  const walletIdFromStorage = walletStorageService.getWalletId();
  if (walletIdFromStorage && payload.walletId && walletIdFromStorage !== payload.walletId) {
    walletStorageService.setWalletId(payload.walletId);
  }
}
async function updatePaymentsInfo(_ref2) {
  let {
    walletStorageService,
    currentPaymentsInfo = {},
    payload = {},
    paymentOption,
    // paymentsInfo.myWallet.paymentOption
    budgetSummaryType = 'monthly',
    // paymentsInfo.interactions.budgetSummaryType
    myWalletConfig,
    // paymentsInfo.myWallet.configs
    paymentCalculationFetcher
  } = _ref2;
  const updatedPayload = {
    ...payload
  };
  clearBudgetIfNeeded(updatedPayload);
  updateWalletIdIfNeeded(walletStorageService, updatedPayload);
  const {
    hasUpdatedBudget,
    hasMonthlyBudget
  } = await calculateBudget({
    currentPaymentsInfo,
    payload: updatedPayload,
    paymentOption,
    budgetSummaryType,
    myWalletConfig,
    paymentCalculationFetcher
  });
  const filteredKeys = walletStorageKeys.filter(key => key !== 'dealType');
  // if payload has at least one key that's saved in wallet storage, set last updated value
  const shouldSetLastUpdated = Object.keys(payload || {}).some(key => filteredKeys.includes(key));
  const {
    newPaymentsInfo,
    success
  } = await updateWalletStorage({
    walletStorageService,
    currentPaymentsInfo,
    payload: updatedPayload,
    shouldSetLastUpdated
  });
  return {
    updated: true,
    hasUpdatedBudget,
    updatedPayload,
    updatedPaymentsInfo: newPaymentsInfo,
    hasMonthlyBudget,
    success
  };
}
export { clearBudgetIfNeeded, updatePaymentsInfo as default, shouldRecalculateBudgetOrMonthlyPayment };
